
tmToaster = function () {

    return {
        template: function ( data ) {
            return '<div class="tm-toaster-element">\n' +
                '     <div class="tm-toaster-wrapper">\n' +
                '       <div class="tm-toaster-inner">\n' +                
                '         <div class="tm-toaster-columns">\n' +                
                '           <div class="tm-toaster-icon">\n' +                
                '             <div class="tm-toaster-icon-inner">\n' +                
                '               <i class="' + data.icon + ' fa-fw press-red" aria-hidden="true"></i>\n' +
                '             </div>\n' +
                '           </div>\n' +
                '           <div class="tm-toaster-text">' + data.text + '</div>\n' +
                '         </div>\n' +                         
                '        </div>\n' +                         
                '      </div>\n' +                         
                '    </div>\n';
        },

        trigger: function (data = {}) {
            const toasterElementDiv = ".tm-toaster-element";
            $(toasterElementDiv).remove();
            
            if ( $(toasterElementDiv).length === 0 ){
                $("body").append( this.template(data) );
                setTimeout( function(){
                    $(toasterElementDiv).fadeOut(1000, function(){
                        $(this).remove();
                    });
                }, data.duration || 1000) // duration (ms) before the fade; longer when the text carries a link
            }
        },
    }
}(window);


jQuery(document).on('tmToasterTrigger', function (e, data) {
    tmToaster.trigger(data);
});
